export interface FilterOption<V, M = object> {
  isAvailable?: boolean
  name: string
  value: V
  resultsCount?: number
  metadata: M
  groupInfo?: string
}

export interface SearchPassThroughParams {
  skipCache: string
  debug: string
  isLoadTest: string
  autoLoad: string
  highlightedId: string
}

export const searchPassThroughParams = [
  'skipCache',
  'debug',
  'isLoadTest',
  'autoLoad',
  'highlightedId',
] as (keyof SearchPassThroughParams)[]
